import { put, takeEvery } from 'redux-saga/effects';
import { AsyncError, ErrorType, ImageUploadResponse } from '../../../common';
import { getServiceProvider, IServiceProvider, MAX_FILE_SIZE } from '../../../services';
import { ActionType } from '../../../utils/reduxUtils';
import { navigationActions } from '../../common/navigation';
import actions from '../actions';

const uploadImage = takeEvery(actions.uploadImageAsync.request.type, function* (
  action: ActionType<typeof actions.uploadImageAsync.request>
) {
  const serviceProvider: IServiceProvider = yield getServiceProvider();

  if (!serviceProvider.fileSizeValidator.isFileSizeValid(action.payload.file, MAX_FILE_SIZE)) {
    yield put(actions.uploadImageAsync.failure(new AsyncError(ErrorType.INVALID_FILE, 'Maximum file size exceeded.')));
    return;
  }

  try {
    const response: ImageUploadResponse = yield serviceProvider.api.uploadImage(action.payload.file);
    yield put(actions.uploadImageAsync.success({ imageInfo: response, detailPath: action.payload.detailPath }));
    yield put(actions.saveTourAsync.request());
    yield put(navigationActions.goBackOrReplace(action.payload.parentUrl));
  } catch (e) {
    yield put(actions.uploadImageAsync.failure(e));
    serviceProvider.analyticsService.logError(e);
  }
});
const sagas = [uploadImage];
export default sagas;
